import { atomHelpers } from '@approvalmax/utils';

export const pushingConnectGLPopupHideState = atomHelpers.createAtomWithStorage<boolean>(
    'pushingConnectGLPopupHideState',
    false
);
